module.exports = __webpack_public_path__ + "KHA.png?298176f3ee5ecf3c9978da533c8f851e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/KHA.png
// module id = 5
// module chunks = 0